const zh_CHT = {
  产品菜单: '產品',
  关于我们菜单: '關於我們',
  帮助中心菜单: '幫助中心',
  信用基础: '信用為基',
  加密支付: '加密支付',
  全币种支持: '全幣種支持',
  全节点承兑: '全節點承兌',
  去中心担保: '去中心擔保',
  立即开始使用: '立即開始使用',
  闪电般的支付体验: '閃電般的支付體驗',
  完成跨境支付: '45秒內完成跨境支付',
  多链支持: '多鏈支持',
  支持主流公链资产: '支持主流公鏈資產',
  实时结算: '即時結算',
  无需等待: '秒級到賬，無需等待',
  超额担保: '超額擔保',
  资金安全有保障: '資金安全有保障',
  一个钱包: '一個錢包',
  所有可能: '所有可能',
  商户收款: '商戶收款',
  全球化支付网关: '全球化支付網關',
  承兑服务: '承兌服務',
  稳定可靠的承兑网络: '穩定可靠的承兌網路',
  数字资产: '數字資產',
  多链资产管理: '多鏈資產管理',
  下载: 'App下載',
  多节点承兑: '多節點承兌',
  全币种支持: '全幣種支持',
  去中心担保: '去中心擔保',
  生态: 'NECO 生態',
  钱包: 'TEPAY Wallet',
  立即下载: '立即下載',
  随时汇币: '隨時隨地幣支付跨國匯款不再難',
  一个钱包: '一個錢包',
  走天下: '走天下',
  海量订单: '海量訂單',
  日进斗金: '日進斗金',
  首页描述: 'TePay是一個去中心化的信用支付基礎設施，不是銀行。金融服務由我們的接受節點網路和基於區塊鏈的智慧合約網路提供支持。抵押和信用機制確保安全合規的交易，而託管和爭議解決則通過我們的DAO仲裁系統進行管理。多鏈互操作性和整合合規模塊為用戶提供無縫、透明的支付體驗，無論是用戶還是商家。',
  轻松交易: '輕鬆交易',
  slide2Text: '通過 TePay 去中心化的多節點網路，實現法幣與數位貨幣的自由、無縫兌換',
  slide2Info: 'TePay 是一個去中心化的支付平台，而非傳統銀行。服務由我們的多節點承兌網路提供，並通過區塊鏈智慧合約加以保障。超額抵押和信用評分機制確保每筆交易都合規且安全。',
  全球通用: '全球通用',
  让每一笔支付: '讓每一筆支付',
  瞬间达成: '瞬間達成',
  slide3Text: '在 TePay 強大的網路中，自由交易法幣與數位貨幣。',
  slide3Info: 'TePay 不侷限於單一貨幣。我們的去中心化平台讓您輕鬆發送、接收並兌換多種貨幣，打破國界限制，享受統一體驗。借助區塊鏈技術和動態信用機制，您的資金始終安全高效地運轉。',
  护航每笔交易: '護航每筆交易',
  去中心化担保: '去中心化擔保',
  安全无忧: '安全無憂',
  slide4Text: '通過去中心化擔保機制，為每筆交易提供信任保障與安全支持。',
  slide4Info: 'TePay 並非傳統銀行，而是通過去中心化擔保機制確保交易安全。我們的系統利用超額抵押、動態信用評分和 DAO 仲裁，為每筆交易提供堅實保障。這一強大的擔保機制有效連接傳統金融與數位資產，確保所有支付均合規、安全、高效。',
  一个钱包走天下: '一個錢包走天下',
  币随时付: '幣隨時付',
  跨境无忧: '跨境無憂',
  slide5Text: '一站式管理所有資產，無論法幣還是數位貨幣，盡在一個安全錢包中。',
  slide5Info: 'TePay 將您的金融世界融為一體，通過一個錢包解決所有支付需求。我們的平台整合資產管理與全球交易，依託先進區塊鏈技術和動態信用機制，為您提供無縫、高效的金融體驗。',
  海量订单: '海量訂單',
  海量订单: '日進斗金',
  slide6Text: '對接商戶與客戶多元幣種需求，獲利無限。',
  slide6Info: 'TePay 的動態匹配引擎打通法幣與數位幣之間的壁壘，使承兌節點無論在商戶還是客戶採用哪種幣種時，都能實現盈利。平台高效結算，每筆交易均助您收益倍增。',
  边兑边赚: '邊兌邊賺',
  信用随行: '信用隨行',
  slide7Text: '每次兌換都讓您收益倍增，同時信用穩步提升。',
  slide7Info: 'TePay 並非傳統銀行，而是通過去中心化擔保機制確保交易安全。我們的系統利用超額抵押、動態信用評分和 DAO 仲裁，為每筆交易提供堅實保障。這一強大的擔保機制有效連接傳統金融與數位資產，確保所有支付均合規、安全、高效。',
  下载TEPAY: '下載TEPAY',
  开启信用支付: '開啟信用支付',
  多币种支持: '多幣種支持',
  多节点承兑描述: '多節點承兌',
  下载Text: '下載',
  链上赋能: '鏈上賦能 社區電商',
  品牌即社区: '品牌即社區',
  消费即投资: '消費即投資',
  本地即全球: '本地即全球',
  首页描述: 'NECO（來客）社區電商平台以 Web3 去中心化信任框架為基底，將真實消費與鏈上透明返利深度融合，重塑用戶、商戶與社區的價值循環，開創共享、可信、可持續的新電商範式。',
  真实消费: '真實消費',
  支撑返利: '支撐返利',
  slide2Text: '買得越多，返得越真',
  slide2Info: 'NECO 只在 訂單已完成並鏈上確認 後，才生成對應債券和積分；返利額度嚴格錨定商家讓利 20 %，無任何超發。這意味著平台的全部獎勵都由 真實現金流 支付，用戶看到的每一筆 NECO／USAI 都可在區塊瀏覽器溯源，徹底隔絕“資金盤”風險。',
  透明积分: '透明積分',
  代币经济: '代幣經濟',
  slide3Text: '積分上鏈，價值可驗',
  slide3Info1: '消費返利被拆分為 NECO 平台幣 與 USAI 穩定幣 兩條帳本：',
  slide3Info2: '前者每日 0.2 % 線性釋放，後者隨銷毀／鑄造自動平衡匯率。',
  slide3Info3: '所有鑄造、銷毀、釋放事件都由智慧合約記錄，任何人可即時查看 錢包餘額、釋放倒計時與歷史交易，讓每一份激勵都擁有公開的“身份證”。',
  多角色: '多角色',
  激励生态: '激勵生態',
  slide4Text1: '用戶、團長、商戶，共贏閉環',
  slide4Info1: '用戶：消費返還 100 % 積分，持 NECO 享漲幅與治理權；',
  slide4Info2: '團長：組織團購、運營社群，拿佣金 + NECO 額外獎勵；',
  slide4Info3: '商戶：讓利換精準訂單，享 0 手續費結算與品牌曝光。',
  slide4Info4: '三方收益都寫進同一套鏈上公式，收入與付出即時對帳，形成自驅動的裂變循環',
  合规保障: '合規保障',
  全程可审: '全程可審',
  slide5Text: '鏈上留痕，監管友好',
  slide5Info1: 'TePay 網關承擔 KYC、法幣對接與支付合規；交易數據、讓利比例、積分分配全部鏈上存證。',
  slide5Info2: '平台還設置 雙預言機、價格緩衝區與 DAO 風控基金，在出現極端行情或政策變動時，可由治理投票觸發限速、回購或暫停機制——讓監管放心、用戶安心、生態長青。',
  合作伙伴: '合作夥伴',
  社区团购: '社區團購',
  社区小店: '社區小店',
  社区空间: '社區空間',
  社区服务: '社區服務',
  NECO优选: 'NECO優選',
  暂未开放: '暫未開放',
  新闻标题: '新聞中心',
  新闻1标题: '創世啟動、APP上線和會員系統開放時間的公告',
  新闻1内容: '各位社區成員：\n\n我們預計於8月5日24點（GMT+8）在Novai SWAP中開放NECO/nUSDT、USAI/nUSDT交易對，完成平台幣和穩定幣的創世啟動。\n\n同時，NECO APP將正式開放註冊，並上線全球會員系統，您可以在該系統中完成以下操作：\n1、用戶註冊和連結分享。\n2、將USDT充值到預充值帳戶成為USAI，並購買VIP會員。\n3、創世節點和普通節點等額積分釋放（獲得NECO收益）。\n4、獲得會員推薦及其團隊積分獎勵，管理自己的團隊。\n5、消費積分（購買會員、團隊獎勵和節點獎勵所得）釋放為NECO。\n6、NECO閃兌成USAI並提現（當前版本支持提現為USDT）。\n7、消費返股的基礎功能（查看NECO幣價、查看SWAP NECO交易兌、查看公告等）。\n\n如遇時間調整，我們將另行公告。',
  返回: '返回',
  消费返股: '消費返股 社區電商',
  全球首个: '全球首個',
  WEB3社区电商平台: 'WEB3社區電商平台',
  消费: '消費',
  赚钱: '賺錢',
  持股: '持股',
  合伙人: '合夥人',
  用户: '用戶',
  股东: '股東',
  不只是电商: 'NECO 不只是電商',
  更是社区电商: '更是社區電商',
  共赢闭环: '用戶、團長、商戶，共贏閉環',
  用户描述: '用戶：消費返還 100 % 積分，持 NECO 享漲幅與治理權；',
  团长描述: '團長：組織團購、運營社群，拿佣金 + NECO 額外獎勵；',
  商户描述: '商戶：讓利換精準訂單，享 0 手續費結算與品牌曝光。',
  三方描述: '三方收益都寫進同一套鏈上公式，收入與付出即時對帳，形成自驅動的裂變循環。',
  购物聊天: 'NECO AI 電商，讓購物像聊天一樣簡單',
  边聊边选: '邊聊邊選',
  聊天助手实时理解你的对话: 'AI 聊天助手即時理解你的對話，',
  就能找到你要的东西: '一句話，就能找到你要的東西。',
  AI优选: 'AI優選',
  的那一刻: '你打開 NECO 的那一刻，',
  已经在等你: '最適合你的商品和服務，已經在等你。',
  时尚分身: '時尚分身',
  监控价格: '替你找好物、監控價格、',
  守护你的消费体验: '守護你的消費體驗。',
  三类团购机制: '三類團購機制',
  附近团: '附近團',
  熟人团: '熟人團',
  优选团: '優選團',
  全球战略布局: '全球戰略布局',
  使命与愿景: 'NECO 的使命與願景',
  使命: '使命',
  愿景: '願景',
  使命描述: '建立公平、透明、可參與的自組織商業系統',
  愿景描述: '讓世界上每一個角落都能點亮一盞社區經濟之光',
  "公告": "公告",
  "铸造销毁协议": "鑄造銷毀協議",
  "SWAP交易": "SWAP交易",
  "NECO社区电商": "NECO社區電商",
  "菜单": "選單",
  "安卓下载": "安卓下載",
  "ios下载": "ios下載",
  "NECO下载": "NECO APP 下載",
  "支持版本": "支持 IOS Android 版本",
  "当前版本": "當前版本",
  "跨链桥": "跨鏈橋",
  "合作伙伴关系": "合作夥伴關係",
  "请加入社交媒体信息": "請加入社交媒體資訊",
  "联系我们": "聯繫我們",
  "版权所有（公司）": "版權所有（公司）",
  "联系我们的邮件请填写": "聯繫我們的郵件請填寫",
  "新闻": "新聞",
  "网页直连": "網頁直連",
  "铸造与销毁协议": "鑄造與銷毀協定",
  "更多": "更多",
  "请通过": "請通過",
  "与我们联系": "與我們聯系",
  "版权所有": "版權所有",
  "联系": "聯繫",
  "智能体": "智慧體",

  
  "全球首个": "全球首個",
  "WEB3社区电商平台": "WEB3社區電商平台",
  "消费": "消費",
  "持股": "持股",
  "升值": "升值",
  "重新定义消费的价值": "重新定義消費的價值",
  "让消费成为财富的起点": "讓消費成為財富的起點",
  "消费即拥有，分享即收益": "消費即擁有，分享即收益",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO 是一套基於 Web3 技術的智能電商基礎設施，通過「消費即持股」機制，讓每一位用戶在購物時獲得真實權益與長期回報。在這裡，消費者不只是用戶，更是平台的擁有者和生態的建設者。",
  "核心技术": "核心技術",
  "基于 Novai Chain 的二层网络": "基於 Novai Chain 的二層網絡",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain 是建構在 Novai Chain 之上的高效能二層網絡，",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "專為高頻電商與支付結算設計，平均出塊時間僅 0.2 秒，TPS 超過 50,000。",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain 將電商的每筆消費行為與激勵記錄上鏈，",
  "让商业行为具备长期可验证性与可追溯性。": "讓商業行為具備長期可驗證性與可追溯性。",
  "高速并行账本结构": "高速並行帳本結構",
  "智能结算与动态费用调节": "智能結算與動態費用調節",
  "消费凭证 NFT 化与积分资产化": "消費憑證 NFT 化與積分資產化",
  "核心特性": "核心特性",
  "链上结算": "鏈上結算",
  "每笔电商交易 0.2 秒确认，安全透明": "每筆電商交易 0.2 秒確認，安全透明",
  "激励协议": "激勵協議",
  "激励消费者、商家、渠道等为NECO做出贡献": "激勵消費者、商家、管道等為NECO做出貢獻",
  "权益积分": "權益積分",
  "用户消费即持有可追踪、可变现的权益积分": "用戶消費即持有可追蹤、可變現的權益積分",
  "共建共享": "共建共享",
  "首个去中心商业自治组织，共建共享NECO电商": "首個去中心商業自治組織，共建共享NECO電商",
  "主要产品": "主要產品",
  "支持电商 RWA 的高性能公链": "支援電商 RWA 的高效能公鏈",
  "稳定币、DEX、去中心信用等电商基础协议": "穩定幣、DEX、去中心信用等電商基礎協議",
  "同时为WEB2和WEB3用户服务的电商APP": "同時為WEB2和WEB3用戶為服務的電商APP",
  "法币和数字货币统一支付及结算体系": "法幣和數位貨幣統一支付及結算體系",
  "竞争优势": "競爭優勢",
  "极速公链": "極速公鏈",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "0.2 秒出塊，支援百萬級併發訂單及支付交易。",
  "全球合规": "全球合規",
  "在全球各地通过 DAO 组织进行本地合规运营。": "在全球各地透過 DAO 組織進行本地合規營運。",
  "电商 RWA": "電商 RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "第一個將現實世界電商完全放在鏈上運行的平台。",
  "商业闭环": "商業閉環",
  "让消费、社交与收益形成价值闭环。": "讓消費、社交與收益形成價值閉環。",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "全球分銷體系讓每個用戶都能成為品牌的傳播者與收益方。",
  "消费者端": "消費者端",
  "注册/消费即得积分奖励，积分每日释放为资产。": "註冊/消費即得積分獎勵，積分每日釋放為資產。",
  "商家端": "商家端",
  "一键接入结算 API，设置折让比例与积分政策。": "一鍵接入結算 API，設定折讓比例與積分政策。",
  "分销端": "分銷端",
  "允许全球用户参与分销，共享收益与品牌成长。": "允許全球用戶參與分銷，共享收益與品牌成長。",
  "NECO 生态系统": "NECO 生態系統",
  "一个融合金融、科技与商业的去中心化生态。": "一個融合金融、科技與商業的去中心化生態。",
  "Neco Chain 公链": "Neco Chain 公鏈",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "商業級高速 Layer 2 網路（Novai L2），提供結算與資料驗證基礎設施。",
  "NECO App": "NECO App",
  "用户购物、签到、邀请与分销的统一入口。": "用戶購物、簽到、邀請與分銷的統一入口。",
  "USAI 稳定币": "USAI 穩定幣",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "用於平台內支付與結算的穩定幣資產，錨定美元價值。",
  "U Card 全球消费卡": "U Card 全球消費卡",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "連接線上線下消費場景，支援積分抵扣與現金返還。",
  "NECO AI 智能系统": "NECO AI 智慧系統",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "透過 AI 分析用戶行為，實現個人化推薦與安全風控。",
  "消费金融该协议": "消費金融該協議",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "提供通用的去中心化金融基礎設施，支援電商資產流通。",
  "稳定币生态": "穩定幣生態",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "建構覆蓋支付、結算與跨境流通的穩定幣網路。",
  "团队及投资人": "團隊及投資人",
  "全球化视野 · 多元化背景。": "全球化視野 · 多元化背景。",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "NECO 團隊成員來自新加坡、中國、阿聯酋等地，擁有電商、金融科技與區塊鏈技術領域超過十年的行業經驗。",
  "投资人": "投資人",
  "运营团队": "營運團隊",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "擁有多年歐洲、中東、南美零售企業創業經驗,曾創建杜拜領先的數位貨幣交易所 加密貨幣的重度信仰者",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "從事杜拜房地產和零售行業多年。擁有豐富的跨國公司管理經驗。",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "曾任職OKX，負責公司品牌和戰略",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Novai Chain 創辦人， 全面支撐NECO技術落地。",
  "官方路线图": "官方路線圖",
  "2025 — 创世与启动": "2025 — 創世與啟動",
  "2025 — 增长与市场拓展": "2025 — 成長與市場拓展",
  "2026 — 生态深化与 AI 赋能": "2026 — 生態深化與 AI 賦能",
  "上半年（Q2–Q3）": "上半年（Q2–Q3）",
  "完成白皮书、制度模型与产品原型开发": "完成白皮書、制度模型與產品原型開發",
  "组织九大社区进行创世启动": "組織九大社區進行創世啟動",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "完成 300 個節點招募，發行 NECO & USAI 代幣，添加初始流動性池",
  "发布 NECO APP BETA 测试版": "發布 NECO APP BETA 測試版",
  "下半年（Q3–Q4）": "下半年（Q3–Q4）",
  "全球社区运营中心部署完成": "全球社區營運中心部署完成",
  "NECO 优选店铺与创世商户上线": "NECO 優選店鋪與創世商戶上線",
  "推动注册用户突破 10 万": "推動註冊用戶突破 10 萬",
  "启动空投及全球电商启动大会": "啟動空投及全球電商啟動大會",
  "Q4：好货推广 & 本地电商": "Q4：好貨推廣 & 本地電商",
  "上线「好货系统」并开放会员商家入驻": "上線「好貨系統」並開放會員商家入駐",
  "在主要国家开通 TePay 法币支付": "在主要國家開通 TePay 法幣支付",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "完成中國、韓國、越南 10 家 NECO Best 本地電商落地",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "海外註冊用戶突破 50 萬，VIP 用戶突破 5 萬",
  "举办第二次社区电商大会，开放跨境卖家注册": "舉辦第二次社區電商大會，開放跨境賣家註冊",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "拓展中東、南美、非洲與歐洲本地市場，整合供應鏈",
  "注册用户突破 100 万，VIP 用户突破 10 万": "註冊用戶突破 100 萬，VIP 用戶突破 10 萬",
  "Q1–Q2：体系完善": "Q1–Q2：體系完善",
  "跨境卖家突破 10 万，商家数量超 10 万": "跨境賣家突破 10 萬，商家數量超 10 萬",
  "举办第一届 NECO 电商生态大会": "舉辦第一屆 NECO 電商生態大會",
  "上线稳定币生态与信用体系": "上線穩定幣生態與信用體系",
  "注册用户突破 500 万，VIP 超过 20 万": "註冊用戶突破 500 萬，VIP 超過 20 萬",
  "Q3–Q4：智能升级": "Q3–Q4：智慧升級",
  "获得主要国家支付牌照，全面上线法币支付服务": "獲得主要國家支付牌照，全面上線法幣支付服務",
  "上线 AI 选品与推荐功能": "上線 AI 選品與推薦功能",
  "商家信用、积分全面上链": "商家信用、積分全面上鏈",
  "NECO Best 优选商家突破 100 家": "NECO Best 優選商家突破 100 家",
  "注册用户突破 1000 万，VIP 超过 50 万": "註冊用戶突破 1000 萬，VIP 超過 50 萬",
  "加入 NECO": "加入 NECO",
  "消费创造财富，社区共建共享。": "消費創造財富，社區共建共享。",
  "一分钟带你了解NECO": "一分鐘帶你瞭解NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO通過鏈上透明的返利機制，讓每一次消費都能獲得真實收益。",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "相比傳統電商，NECO的利潤由智慧合約按比例即時返還，0抽傭、0壓貨",
  "用户与商家共享增长红利。": "用戶與商家共亯增長紅利。",
  "全球版": "全球版",
  "中国版": "中國版",
}

// eslint-disable-next-line camelcase
export default zh_CHT



// WEBPACK FOOTER //
// ./src/i18n/config/zh_CHT.js